export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0
// 是否为电话号码
export const isPhone = (str: string): boolean => /^[1][0-9]{10}$/.test(str)

// 8-16位不能纯数字纯英文
/* eslint-disable */
export const isPassword = (str: string): boolean => /^(?=.*[0-9\!@#\$%\^&\*])(?=.*[a-zA-Z]).{8,16}$/.test(str)
/* eslint-disable */

export const isExternal = (path: string): boolean => /^(https?:|mailto:|tel:)/.test(path)
